import { z } from "zod";
/** Dates cross the wire as YYYY-MM-DD, never as a timestamp. */
export const isoDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Use the format YYYY-MM-DD");
/**
 * Money stays a string from the form all the way to Prisma's Decimal column.
 * It is never parsed into a JS number, because 0.1 + 0.2 is not 0.3 and a
 * report total you cannot trust is worse than no report at all.
 */
export const amountSchema = z
    .union([z.string(), z.number()])
    .transform((v) => String(v).trim())
    .refine((v) => /^\d{1,10}(\.\d{1,2})?$/.test(v), "Enter an amount with at most two decimal places");
export const odometerSchema = z.coerce
    .number()
    .int("Odometer must be a whole number")
    .min(0)
    .max(9_999_999);
/**
 * Accepts 9876543210, +91 98765 43210, 0919876543210 and friends.
 * Always returns 91XXXXXXXXXX — the format WhatsApp Cloud API also expects.
 */
export function normalizePhone(input) {
    const digits = input.replace(/\D/g, "");
    const local = digits.length > 10 ? digits.slice(-10) : digits;
    if (local.length !== 10)
        return null;
    if (!/^[6-9]/.test(local))
        return null; // Indian mobile numbers start 6-9
    return `91${local}`;
}
export const phoneSchema = z
    .string()
    .transform((v) => normalizePhone(v))
    .refine((v) => v !== null, "Enter a valid 10-digit mobile number");
/** Display helper: 919876543210 -> +91 98765 43210 */
export function formatPhone(e164) {
    const local = e164.replace(/\D/g, "").slice(-10);
    return `+91 ${local.slice(0, 5)} ${local.slice(5)}`;
}
const inr = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
});
export function formatINR(amount) {
    return inr.format(typeof amount === "string" ? Number(amount) : amount);
}
/** Compact form for dashboard tiles: ₹1.2L, ₹45.6K */
export function formatINRCompact(amount) {
    const n = typeof amount === "string" ? Number(amount) : amount;
    if (n >= 10_000_000)
        return `₹${(n / 10_000_000).toFixed(2)}Cr`;
    if (n >= 100_000)
        return `₹${(n / 100_000).toFixed(2)}L`;
    if (n >= 1_000)
        return `₹${(n / 1_000).toFixed(1)}K`;
    return formatINR(n);
}
//# sourceMappingURL=primitives.js.map